import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { SingleDatePicker } from '../DatePickers';

export const SingleDatePickerWrapper = forwardRef(function SingleDatePickerWrapper(
    { id, date, onDateChange, isInvalid, ...props },
    forwardedRef
) {
    const [isFocused, setFocused] = useState(false);

    const onFocusChange = ({ focused }) => {
        setFocused(focused);
    };

    return (
        <SingleDatePicker
            ref={forwardedRef}
            id={id}
            date={date}
            onDateChange={onDateChange}
            focused={isFocused}
            onFocusChange={onFocusChange}
            {...props}
        />
    );
});

SingleDatePickerWrapper.propTypes = {
    id: PropTypes.string,
    date: PropTypes.object,
    onDateChange: PropTypes.func,
    isInvalid: PropTypes.bool,
};
